import React from 'react';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import styled from 'styled-components';

export interface HeaderWithDividerProps {
    readonly header: string;
    readonly Slot?: React.ReactNode;
}

export const StyledHeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    width: 100%;
    gap: 20px;
`;

export const StyledContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

export function HeaderWithDivider({ header, Slot }: HeaderWithDividerProps) {
    return (
        <StyledHeaderContainer>
            <StyledContainer>
                <Typography variant="h2" sx={{ margin: 0, lineHeight: 1 }}>
                    {header}
                </Typography>
                {Slot && Slot}
            </StyledContainer>
            <Divider
                orientation="horizontal"
                sx={{
                    width: '100%',
                }}
            />
        </StyledHeaderContainer>
    );
}

export default HeaderWithDivider;
